import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as selectorsConfig from 'store/config/reducer';
import DefaultSelect from 'components/DefaultSelect';

const EstadoInputV2 = ({ estados, onSelect, estado, isRequired, error, helperText, disabled }) => {
  const handleChange = (event) => onSelect(event.target.value);
  return (
    <DefaultSelect 
      error={error}
      helperText={helperText}
      isRequired={isRequired}
      label="Estado"
      onSelect={handleChange}
      options={estados}
      value={estado}
      disabled={disabled}
    />
  );
}

EstadoInputV2.propTypes = {
  error: PropTypes.any, estado: PropTypes.string, estados: PropTypes.array.isRequired,
  helperText: PropTypes.string, isRequired: PropTypes.any, onSelect: PropTypes.func.isRequired
};
EstadoInputV2.defaultProps = { error: null, helperText: null, isRequired: false };

const mapStateToProps = state => ({ estados: selectorsConfig.getEstados(state) });
export default connect(mapStateToProps, null)(EstadoInputV2);
